<!-- Footer Section start -->
<div class="copyright-section flex flex-row flex-wrap justify-content-center">
    <a [routerLink]="language.route('/imprint')" class="imprint">{{ 'MENU.IMPRINT' | translate }}</a>

    <div class="vl">|</div>

    <p>© {{ 'COMPANY_NAME' | translate }} {{ today | date:'y' }}</p>
</div>
